export default {
    props: ['banks-list', 'current-selected-bank-id', 'assoc-banks', "allowed-commissions", "commission-configuration-id", "currencies", "current-currency"],
    data() {
        return {
            selected_bank: {},
            selected_banks: [],
            selected_bank_ids: [],
            selected_bank_id: null,
            selected_currency: {},
            selected_commission: {},
        };
    },
    mounted() {
        if (this.currentSelectedBankId) {
            this.selected_bank = this.banksList.filter((v) => { return v.id == this.currentSelectedBankId });
            this.selected_bank_id = this.currentSelectedBankId;
        }
        this.selected_banks = this.assocBanks

        if(this.currentCurrency) {
            this.selected_currency = this.currencies.filter((x) => {return x.symbol == this.currentCurrency})
        }
        
        if(this.commissionConfigurationId) {
            this.selected_commission = this.allowedCommissions.filter((x) => {return x.id == this.commissionConfigurationId})
        }
    },
    methods: {
        getSelected() {
            this.selected_bank_id;
        },
        updateSelection(v) {
            if (v[0]) {
                this.selected_bank_id = v[0].id;
            }
            if(v.id){
                this.selected_bank_id = v.id;
            }
        },
        setSelected: function (v) {
            this.selected_bank_id = v.id;
        },
        setSelectedIds: function (v) {
            this.selected_bank_ids = v.map(v=> {return v.id}) ;
        },
        filterCommissions: function (v) {
            this.selected_currency = v
            this.selected_commission = {}
        },
        setCommissionId: function (v) {
            this.selected_commission = v
        }
    },
    computed: {
        currency: function () {
            if (this.selected_currency && this.selected_currency.symbol) {
                return this.selected_currency.symbol;
            } else {
                return this.currentCurrency;
            }
        },
        commission_configuration_id: function () {
            if(this.commissionConfigurationId) {               
                return this.commissionConfigurationId
            }
            else {
                return this.selected_commission.id
            }
        },
        commissions: function () {
            if(Object.keys(this.selected_currency).length > 0) {
                return this.allowedCommissions.filter((x) => {return x.currency_id == this.selected_currency.currency_id})
            }
            else if(this.allowedCommissions){
                return this.allowedCommissions
            }
            else {
                return []
            }
        }
    }
}